/*
 * Delivery region selector.
 * State lives in the `bk_delivery` cookie and on <html data-delivery-state / data-delivery-zones>
 * (set early by snippets/delivery-region-head.liquid). Product hiding itself is pure CSS; this file
 * handles the popup, header label, cart warnings and small layout refreshes.
 * Click & Collect: { mode: 'collect', store, state: 'VIC' } — filters on the VIC range; not passed to checkout.
 */
(function () {
  var BD = window.BlakeawayDelivery;
  if (!BD) return;

  var cfg = BD.config;
  var PROMPTED_COOKIE = 'bk_delivery_prompted';
  var STATE_NAMES = {
    VIC: 'Victoria',
    NSW: 'New South Wales',
    ACT: 'ACT',
    QLD: 'Queensland',
    SA: 'South Australia',
    WA: 'Western Australia',
    TAS: 'Tasmania',
    NT: 'Northern Territory',
  };

  var modal = document.getElementById('DeliveryRegionModal');

  // Only touch the DOM when content changes — the cart MutationObserver would otherwise re-trigger itself.
  function setHtml(el, html) {
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Fallback when DataJet has no match: standard AU postcode ranges.
  function stateFromPostcode(postcode) {
    var pc = parseInt(postcode, 10);
    if (isNaN(pc) || String(postcode).trim().length !== 4) return null;
    if ((pc >= 200 && pc <= 299) || (pc >= 2600 && pc <= 2618) || (pc >= 2900 && pc <= 2920)) return 'ACT';
    if (pc >= 800 && pc <= 999) return 'NT';
    if ((pc >= 1000 && pc <= 2599) || (pc >= 2619 && pc <= 2899) || (pc >= 2921 && pc <= 2999)) return 'NSW';
    if ((pc >= 3000 && pc <= 3999) || (pc >= 8000 && pc <= 8999)) return 'VIC';
    if ((pc >= 4000 && pc <= 4999) || (pc >= 9000 && pc <= 9999)) return 'QLD';
    if (pc >= 5000 && pc <= 5999) return 'SA';
    if (pc >= 6000 && pc <= 6999) return 'WA';
    if (pc >= 7000 && pc <= 7999) return 'TAS';
    return null;
  }

  /* ---------- Labels ---------- */

  function delivers(state) {
    return !cfg.delivered.length || cfg.delivered.indexOf(state) > -1;
  }

  function isCollect() {
    return BD.mode === 'collect';
  }

  // "delivery to WA" / "Click & Collect from Brighton" — used in cart and grid messages.
  function placeHtml(zone) {
    return isCollect()
      ? 'Click &amp; Collect from <strong>' + escapeHtml(BD.selection.store) + '</strong>'
      : 'delivery to <strong>' + escapeHtml(zone) + '</strong>';
  }

  function updateLabels() {
    BD.paintLabels();
    document.querySelectorAll('[data-delivery-state-text]').forEach(function (el) {
      var sel = BD.selection;
      el.textContent = isCollect()
        ? sel.store
        : sel && sel.suburb
        ? sel.suburb + ', ' + sel.state
        : STATE_NAMES[BD.state] || BD.state;
    });
    document.querySelectorAll('[data-delivery-notice-for]').forEach(function (el) {
      el.textContent = isCollect() ? 'for Click & Collect from' : 'for delivery to';
    });
    document.querySelectorAll('[data-delivery-state-choice]').forEach(function (btn) {
      var active = !!BD.selection && btn.getAttribute('data-delivery-state-choice') === BD.state;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active);
    });
  }

  /* ---------- Selection ---------- */

  function select(sel) {
    sel.ts = Date.now();
    BD.writeCookie(sel);
    BD.apply(sel);
    refresh();
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'delivery_location_set', {
        mode: sel.mode || 'delivery',
        state: sel.state,
        postcode: sel.postcode || '',
        store: sel.store || '',
      });
    }
    document.dispatchEvent(new CustomEvent('delivery:change', { detail: { state: BD.state, zones: BD.zones } }));
  }

  function reset() {
    document.cookie = cfg.cookie + '=; path=/; max-age=0';
    BD.apply(null);
    refresh();
    document.dispatchEvent(new CustomEvent('delivery:change', { detail: { state: BD.state, zones: BD.zones } }));
  }

  function refresh() {
    updateLabels();
    checkCart();
    refreshLayouts();
  }

  /* ---------- Restriction check (cart) — mirrors snippets/delivery-region-attrs.liquid ---------- */

  function isRestricted(tagsCsv) {
    var no = [];
    var only = [];
    String(tagsCsv || '')
      .split(',')
      .forEach(function (tag) {
        var t = tag.trim().toLowerCase();
        var i = t.indexOf(':');
        if (i === -1) return;
        var key = t.slice(0, i).trim();
        var vals = t
          .slice(i + 1)
          .toUpperCase()
          .split(/[\s/|]+/)
          .filter(Boolean);
        if (key === 'no-delivery') no = no.concat(vals);
        if (key === 'delivery-only') only = only.concat(vals);
      });
    for (var z = 0; z < BD.zones.length; z++) {
      if (no.indexOf(BD.zones[z]) > -1) return BD.zones[z];
    }
    if (only.length && only.indexOf(BD.state) === -1) return BD.state;
    return null;
  }

  function checkCart() {
    var rows = document.querySelectorAll('.cart-item[data-product-tags]');
    var blockedCount = 0;
    var blockedZone = BD.state;

    rows.forEach(function (row) {
      var zone = isRestricted(row.getAttribute('data-product-tags'));
      var blocked = !!zone;
      if (zone) blockedZone = zone;
      row.classList.toggle('is-delivery-restricted', blocked);
      var details = row.querySelector('.cart-item__details');
      var note = row.querySelector('.delivery-cart-item-note');
      if (blocked && details && !note) {
        note = document.createElement('p');
        note.className = 'delivery-cart-item-note';
        details.appendChild(note);
      }
      if (note) {
        note.hidden = !blocked;
        setHtml(note, blocked ? 'Not available for ' + placeHtml(zone).replace(/<\/?strong>/g, '') + ' \u2014 please remove.' : '');
      }
      if (blocked) blockedCount++;
    });

    var block = cfg.blockCheckout && blockedCount > 0;
    document.documentElement.classList.toggle('delivery-cart-blocked', block);

    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      if (block) {
        btn.setAttribute('disabled', '');
        btn.setAttribute('data-delivery-disabled', '');
      } else if (btn.hasAttribute('data-delivery-disabled')) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('data-delivery-disabled');
      }

      var parent = btn.parentNode;
      var warning = parent.querySelector(':scope > .delivery-cart-warning');
      if (blockedCount > 0 && !warning) {
        warning = document.createElement('div');
        warning.className = 'delivery-cart-warning';
        parent.insertBefore(warning, btn);
      }
      if (warning) {
        warning.hidden = blockedCount === 0;
        setHtml(
          warning,
          blockedCount
          ? 'Some items in your cart aren’t available for ' +
            placeHtml(blockedZone) +
            '. Remove them or <button type="button" class="link" data-delivery-open="">' +
            (isCollect() ? 'change your store' : 'change your delivery location') +
            '</button>'
          : ''
        );
      }
    });
  }

  function observeCart() {
    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(checkCart, 50);
    });
    document.querySelectorAll('cart-drawer, cart-items, #main-cart-footer').forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  /* ---------- Layout refreshes ---------- */

  function refreshLayouts() {
    // Swiper skips display:none slides, but needs telling that they changed.
    updateVisibleSwipers();

    // Friendly message when every product in a collection/search grid is hidden.
    document.querySelectorAll('#product-grid').forEach(function (grid) {
      var items = grid.querySelectorAll(':scope > li');
      var visible = Array.prototype.some.call(items, function (li) {
        return getComputedStyle(li).display !== 'none';
      });
      var msg = grid.parentNode.querySelector(':scope > .delivery-empty-grid');
      if (items.length && !visible) {
        if (!msg) {
          msg = document.createElement('div');
          msg.className = 'delivery-empty-grid';
          grid.parentNode.insertBefore(msg, grid.nextSibling);
        }
        setHtml(
          msg,
          '<p>None of these products are available for ' +
            placeHtml(BD.state) +
            '.</p><button type="button" class="button button--secondary" data-delivery-open="">' +
            (isCollect() ? 'Change store' : 'Change delivery location') +
            '</button>'
        );
        msg.hidden = false;
      } else if (msg) {
        msg.hidden = true;
      }
    });

    // Product notice: hide "Try this version instead" when every alternative is hidden for this location.
    document.querySelectorAll('.delivery-notice').forEach(function (notice) {
      var list = notice.querySelector('.delivery-notice__alts');
      if (!list) return;
      var any = Array.prototype.some.call(list.children, function (li) {
        return getComputedStyle(li).display !== 'none';
      });
      list.hidden = !any;
      var intro = notice.querySelector('[data-delivery-alt-intro]');
      if (intro) intro.hidden = !any;
    });
  }

  function updateVisibleSwipers() {
    document.querySelectorAll('.swiper').forEach(function (el) {
      if (el.swiper && el.offsetParent !== null && typeof el.swiper.update === 'function') el.swiper.update();
    });
  }

  // Filters/sorting re-render the product grid via AJAX — recheck the empty-grid message afterwards.
  function observeGrids() {
    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(refreshLayouts, 100);
    });
    document.querySelectorAll('#ProductGridContainer, #product-grid').forEach(function (el) {
      observer.observe(el.parentNode || el, { childList: true, subtree: true });
    });
  }

  /* ---------- Modal ---------- */

  function stepEl(name) {
    return modal.querySelector('[data-delivery-step="' + name + '"]');
  }

  function showStep(name) {
    modal.setAttribute('data-step', name);
    modal.querySelectorAll('[data-delivery-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-delivery-step') !== name;
    });
    modal.querySelectorAll('[data-delivery-results]').forEach(function (el) {
      el.innerHTML = '';
    });
    modal.querySelectorAll('[data-delivery-mode-choice]').forEach(function (btn) {
      var collectBtn = btn.getAttribute('data-delivery-mode-choice') === 'collect';
      btn.setAttribute('aria-pressed', collectBtn === (name === 'collect'));
    });
    var field = stepEl(name).querySelector('input[name="search"]');
    if (field && window.matchMedia('(min-width: 750px)').matches) field.focus();
  }

  // Only release the page scroll lock if we set it (a menu drawer or quick-add may own it instead).
  // Tracked on <body> because the dialog's close event fires asynchronously and can land after a quick reopen.
  function lockScroll() {
    var body = document.body;
    if (!body.classList.contains('overflow-hidden') || body.hasAttribute('data-delivery-lock')) {
      body.classList.add('overflow-hidden');
      body.setAttribute('data-delivery-lock', '');
    }
  }

  // Store buttons behave like radios; the choice is only saved on "Confirm store".
  function pickStore(store) {
    modal.querySelectorAll('[data-delivery-store-choice]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-delivery-store-choice') === store);
    });
  }

  function pickedStore() {
    var btn = modal.querySelector('[data-delivery-store-choice][aria-pressed="true"]');
    return btn ? btn.getAttribute('data-delivery-store-choice') : null;
  }

  function openModal() {
    if (!modal || modal.hasAttribute('open')) return;
    updateLabels();
    var collect = isCollect() && !!stepEl('collect');
    if (stepEl('collect')) pickStore(collect ? BD.selection.store : null);
    showStep(collect ? 'collect' : 'ask');
    var field = stepEl('ask').querySelector('input[name="search"]');
    if (field && !collect && BD.selection && BD.selection.postcode) field.value = BD.selection.postcode;
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      // Browsers without <dialog> (iOS < 15.4): show as a fixed overlay instead.
      modal.classList.add('delivery-modal--fallback');
      modal.setAttribute('open', '');
    }
    lockScroll();
  }

  function closeModal() {
    if (!modal || !modal.hasAttribute('open')) return;
    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
      onClose();
    }
  }

  function onClose() {
    if (modal.hasAttribute('open')) return; // reopened before this close event arrived
    if (document.body.hasAttribute('data-delivery-lock')) {
      document.body.classList.remove('overflow-hidden');
      document.body.removeAttribute('data-delivery-lock');
    }
    document.cookie = PROMPTED_COOKIE + '=1; path=/; max-age=31536000; SameSite=Lax';
  }

  // DataJet returns full state names ("Victoria"); normalise to codes.
  var STATE_CODES = {};
  Object.keys(STATE_NAMES).forEach(function (code) {
    STATE_CODES[code.toLowerCase()] = code;
    STATE_CODES[STATE_NAMES[code].toLowerCase()] = code;
  });
  STATE_CODES['australian capital territory'] = 'ACT';

  function stateCode(value) {
    return STATE_CODES[String(value || '').trim().toLowerCase()] || null;
  }

  // One DataJet row per suburb *per delivery day* — group into { suburb, postcode, state, deliveries[] }.
  function groupMatches(matches) {
    var groups = [];
    var byKey = {};
    matches.forEach(function (m) {
      var state = stateCode(m.state);
      if (!state || cfg.states.indexOf(state) === -1) return;
      var key = [m.suburb, m.postcode, state].join('|');
      if (!byKey[key]) {
        byKey[key] = { suburb: m.suburb, postcode: String(m.postcode), state: state, deliveries: [] };
        groups.push(byKey[key]);
      }
      byKey[key].deliveries.push(m);
    });
    return groups;
  }

  function soonest(groups) {
    var all = [];
    groups.forEach(function (g) {
      all = all.concat(g.deliveries);
    });
    all.sort(function (x, y) {
      return String(x.next_delivery_date).localeCompare(String(y.next_delivery_date));
    });
    return all[0] || null;
  }

  // "2026-10-02" -> "Friday 2 October"
  function formatDate(iso) {
    var parts = String(iso || '').split('-');
    if (parts.length !== 3) return '';
    var d = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    return d.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  function titleCase(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/\b[a-z]/g, function (c) {
        return c.toUpperCase();
      });
  }

  function showSuccess(place, delivery) {
    var step = stepEl('success');
    step.querySelector('[data-delivery-success-place]').textContent = place;

    var card = step.querySelector('[data-delivery-next]');
    var date = delivery && (formatDate(delivery.next_delivery_date) || delivery.next_delivery_date_formatted);
    card.hidden = !date;
    if (date) {
      step.querySelector('[data-delivery-next-date]').textContent = date;
      var cutoff = delivery.order_cutoff_date
        ? 'Order by ' + formatDate(delivery.order_cutoff_date) + (delivery.order_cutoff_time ? ', ' + delivery.order_cutoff_time : '')
        : '';
      step.querySelector('[data-delivery-next-cutoff]').textContent = cutoff;
    }

    // Everything is available in the default state (VIC); elsewhere some items are filtered out.
    step.querySelector('[data-delivery-restricted-note]').hidden = BD.state === cfg.defaultState;

    // Picked a whole state we only partly cover (e.g. QLD) -> nudge them to check their postcode.
    var partialNote = step.querySelector('[data-delivery-partial-note]');
    var partial =
      !!cfg.partialNote && !(BD.selection && BD.selection.postcode) && (cfg.partial || []).indexOf(BD.state) > -1;
    partialNote.hidden = !partial;
    if (partial) renderPartialNote(partialNote.querySelector('[data-delivery-partial-text]'));
    showStep('success');
  }

  // "enter your postcode" in the note becomes the link back to postcode entry (or one is added after the note).
  function renderPartialNote(el) {
    var text = cfg.partialNote.replace(/\[state\]/g, STATE_NAMES[BD.state] || BD.state);
    var phrase = 'enter your postcode';
    var at = text.toLowerCase().lastIndexOf(phrase);
    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'delivery-modal__inline-link';
    link.setAttribute('data-delivery-step-to', 'ask');

    el.textContent = '';
    if (at > -1) {
      link.textContent = text.slice(at, at + phrase.length);
      el.append(text.slice(0, at), link, text.slice(at + phrase.length));
    } else {
      link.textContent = 'Enter postcode';
      el.append(text + ' ', link);
    }
  }

  // Success if we deliver to the selected state, otherwise the "just yet" step.
  function showResult(place, delivery) {
    if (delivers(BD.state)) showSuccess(place, delivery);
    else showOutside(place);
  }

  function showOutside(place) {
    stepEl('outside').querySelector('[data-delivery-outside-place]').textContent = place;
    showStep('outside');
  }

  function showMessage(stepName, html) {
    stepEl(stepName).querySelector('[data-delivery-results]').innerHTML =
      '<p class="delivery-modal__error">' + html + '</p>';
  }

  function lookup(form, value) {
    var stepName = form.closest('[data-delivery-step]').getAttribute('data-delivery-step');
    var button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    var label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Checking\u2026';
    stepEl(stepName).querySelector('[data-delivery-results]').innerHTML = '';

    // Don't let a slow app proxy hang the popup — give up after 8s and fall back to postcode ranges.
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller && setTimeout(function () {
      controller.abort();
    }, 8000);

    var request = cfg.endpoint
      ? fetch(cfg.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ search: value }),
          signal: controller ? controller.signal : undefined,
        }).then(function (res) {
          return res.json();
        })
      : Promise.reject(new Error('No endpoint'));

    request
      .then(function (data) {
        if (!data || !data.ok) throw new Error('Lookup failed');
        var groups = groupMatches(data.matches || []);
        if (!groups.length) return notFound(stepName, value);

        var locations = {};
        groups.forEach(function (g) {
          locations[g.state + '|' + g.postcode] = true;
        });
        if (Object.keys(locations).length === 1) return chooseGroups(groups);
        renderChoices(stepName, groups); // e.g. "Richmond" exists in VIC, NSW, QLD and TAS
      })
      .catch(function () {
        // DataJet unavailable — still honour the postcode so filtering works, just without delivery dates.
        var state = stateFromPostcode(value);
        if (state) {
          select({ state: state, postcode: value.trim(), source: 'user' });
          showResult(value.trim());
        } else {
          showMessage(stepName, 'Something went wrong. Please try your postcode again.');
        }
      })
      .finally(function () {
        clearTimeout(timer);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
      });
  }

  // All groups share one state + postcode (e.g. 3146 = Glen Iris + Tooronga) -> select straight away.
  function chooseGroups(groups) {
    var first = groups[0];
    select({
      state: first.state,
      postcode: first.postcode,
      suburb: groups.length === 1 ? first.suburb : null,
      source: 'user',
    });
    showSuccess(groups.length === 1 ? titleCase(first.suburb) + ' ' + first.postcode : first.postcode, soonest(groups));
  }

  function notFound(stepName, value) {
    var state = stateFromPostcode(value);
    if (!state) {
      showMessage(stepName, 'We couldn’t find “' + escapeHtml(value) + '”. Please try your postcode instead.');
      return;
    }
    // Known Australian postcode we don't deliver to — set the state so products are still filtered correctly.
    select({ state: state, postcode: value.trim(), source: 'user' });
    showOutside(value.trim());
  }

  function renderChoices(stepName, groups) {
    var box = stepEl(stepName).querySelector('[data-delivery-results]');
    box._groups = groups;
    box.innerHTML =
      '<p class="delivery-modal__pick">Which one did you mean?</p><ul class="delivery-modal__matches list-unstyled" role="list">' +
      groups
        .map(function (g, i) {
          return (
            '<li><button type="button" class="delivery-modal__match" data-delivery-match="' +
            i +
            '">' +
            escapeHtml(titleCase(g.suburb) + ' ' + g.postcode + ' (' + g.state + ')') +
            '</button></li>'
          );
        })
        .join('') +
      '</ul>';
  }

  function bindModal() {
    if (!modal) return;

    modal.querySelectorAll('[data-delivery-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var value = form.querySelector('input[name="search"]').value.trim();
        var stepName = form.closest('[data-delivery-step]').getAttribute('data-delivery-step');
        if (value) lookup(form, value);
        else showMessage(stepName, 'Please enter your postcode or suburb.');
      });
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) return closeModal(); // backdrop

      var matchBtn = e.target.closest('[data-delivery-match]');
      if (matchBtn) {
        var group = matchBtn.closest('[data-delivery-results]')._groups[+matchBtn.getAttribute('data-delivery-match')];
        select({ state: group.state, postcode: group.postcode, suburb: group.suburb, source: 'user' });
        showSuccess(titleCase(group.suburb) + ' ' + group.postcode, soonest([group]));
        return;
      }

      var stateBtn = e.target.closest('[data-delivery-state-choice]');
      if (stateBtn) {
        var state = stateBtn.getAttribute('data-delivery-state-choice');
        select({ state: state, source: 'user' });
        showResult(STATE_NAMES[state]);
        return;
      }

      var modeBtn = e.target.closest('[data-delivery-mode-choice]');
      if (modeBtn) {
        var step = modeBtn.getAttribute('data-delivery-mode-choice') === 'collect' ? 'collect' : 'ask';
        if (modal.getAttribute('data-step') !== step) showStep(step);
        return;
      }

      var storeBtn = e.target.closest('[data-delivery-store-choice]');
      if (storeBtn) {
        pickStore(storeBtn.getAttribute('data-delivery-store-choice'));
        stepEl('collect').querySelector('[data-delivery-results]').innerHTML = '';
        return;
      }

      if (e.target.closest('[data-delivery-collect-confirm]')) {
        var store = pickedStore();
        if (!store) return showMessage('collect', 'Please choose a store.');
        select({ mode: 'collect', store: store, state: cfg.collectState, source: 'user' });
        closeModal();
        return;
      }

      var stepBtn = e.target.closest('[data-delivery-step-to]');
      if (stepBtn) return showStep(stepBtn.getAttribute('data-delivery-step-to'));

      if (e.target.closest('[data-delivery-close]')) closeModal();
    });

    modal.addEventListener('close', onClose);
    // Fallback overlay has no native Escape handling.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('delivery-modal--fallback')) closeModal();
    });
  }

  /* ---------- Init ---------- */

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-delivery-open]');
    if (!opener || (modal && modal.contains(opener))) return;
    e.preventDefault();
    // Close the cart drawer first so the dialog isn't stacked behind it.
    var drawer = document.querySelector('cart-drawer.active');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    openModal();
  });

  bindModal();
  refresh();
  observeCart();
  observeGrids();
  document.addEventListener('shopify:section:load', refresh);

  // Collection slider tabs (collection-filter-slider) un-hide a Swiper that was 0-width when we last updated.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[onclick*="SwiperShow"]')) setTimeout(updateVisibleSwipers, 50);
  });

  function busy() {
    return (
      document.body.classList.contains('overflow-hidden') ||
      !!document.querySelector('cart-drawer.active, details[open].menu-opening, quick-add-modal[open]')
    );
  }

  var prompted = /(?:^|; )bk_delivery_prompted=/.test(document.cookie);
  var designMode = window.Shopify && window.Shopify.designMode;
  if (cfg.popup && !BD.selection && !prompted && !designMode) {
    var attempts = 0;
    var autoOpen = function () {
      if (BD.selection) return;
      // Wait for an open menu/drawer to close rather than stacking on top of it.
      if (busy() && attempts++ < 15) return setTimeout(autoOpen, 2000);
      if (!busy()) openModal();
    };
    setTimeout(autoOpen, Math.max(0, Number(cfg.popupDelay) || 0) * 1000);
  }
})();
